module.exports = "https://trybtryb-legacy.web.app/img/neon-waves.a0973835.webp";